import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: '',
    template: `<div class="main-layout-wrapper">
        <app-navigation>
            <app-loading-animation></app-loading-animation>
            <div class="content" [class.fixed-content]="isFixed">
                <router-outlet></router-outlet>
            </div>
        </app-navigation>
    </div>`
})
export class MainLayoutComponent {
    private fixedPageList = ['/clientes/detalle', '/sucursales/detalle'];

    get isFixed(): boolean {
        return this.fixedPageList.some((x) => x === this.router.url);
    }

    constructor(private router: Router) {}
}
